var _path, _rect, _path2, _path3, _path4, _mask, _rect2, _rect3, _path5, _path6, _path7, _mask2, _rect4, _rect5, _ellipse, _ellipse2, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.6822 21C104.248 28.757 109.748 54.1187 102.114 77.2516C94.4799 100.384 76.603 112.529 54.0371 104.771C31.4712 97.0145 2.317 84.2492 9.95099 61.1164C17.585 37.9835 59.1163 13.243 81.6822 21Z",
    fill: "#EEF0FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.8397,
    y: 32.0785,
    width: 65.365,
    height: 44.7224,
    rx: 2.15,
    fill: "white",
    stroke: "#0F255F",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.991 60.4951H94.5526",
    stroke: "#0F255F",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.995 67.5498H64.5236V65.5498H34.995V67.5498Z",
    fill: "#0F255F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.995 72.5957H53.5129V70.5957H34.995V72.5957Z",
    fill: "#0F255F"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.041,
    y: 64.5312,
    width: 8.00701,
    height: 8.07345,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.041,
    y: 64.5312,
    width: 8.00701,
    height: 8.07345,
    rx: 1,
    fill: "#F5F5F5",
    stroke: "#0F255F",
    strokeWidth: 3,
    mask: "url(#path-6-inside-1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.829,
    y: 43.1801,
    width: 65.365,
    height: 44.7224,
    rx: 2.15,
    fill: "white",
    stroke: "#0F255F",
    strokeWidth: 1.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 71.5967H83.5418",
    stroke: "#0F255F",
    strokeWidth: 1.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9843 76.9014C23.57 76.9014 23.2343 77.2372 23.2343 77.6514C23.2343 78.0656 23.57 78.4014 23.9843 78.4014V76.9014ZM53.5129 78.4014C53.9271 78.4014 54.2629 78.0656 54.2629 77.6514C54.2629 77.2372 53.9271 76.9014 53.5129 76.9014V78.4014ZM23.9843 78.4014H53.5129V76.9014H23.9843V78.4014Z",
    fill: "#0F255F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9843 81.9473C23.57 81.9473 23.2343 82.2831 23.2343 82.6973C23.2343 83.1115 23.57 83.4473 23.9843 83.4473V81.9473ZM42.5022 83.4473C42.9164 83.4473 43.2522 83.1115 43.2522 82.6973C43.2522 82.2831 42.9164 81.9473 42.5022 81.9473V83.4473ZM23.9843 83.4473H42.5022V81.9473H23.9843V83.4473Z",
    fill: "#0F255F"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.0303,
    y: 75.6328,
    width: 8.00701,
    height: 8.07345,
    rx: 1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71.0303,
    y: 75.6328,
    width: 8.00701,
    height: 8.07345,
    rx: 1,
    fill: "#F5F5F5",
    stroke: "#0F255F",
    strokeWidth: 3,
    mask: "url(#path-11-inside-2)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1165,
    y: 61.9521,
    width: 11.678,
    height: 2.01863,
    rx: 1,
    fill: "#0F255F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.9987,
    cy: 55.4493,
    rx: 2.00127,
    ry: 2.01863,
    fill: "#0F255F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.4667,
    cy: 55.4493,
    rx: 2.00127,
    ry: 2.01863,
    fill: "#0F255F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.808 35.0996L101.279 34.7689M99.4031 29.7759L104.34 25.8138M95.2275 26.386L95.8884 21.5172",
    stroke: "#0F255F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataAvailable);
export default __webpack_public_path__ + "static/media/no-data-available.c796a3d5d5f7cf1c1b594fea7e4a479b.svg";
export { ForwardRef as ReactComponent };